"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleBlock = exports.SubtitleBlock = exports.LabelText = exports.IconContainer = exports.ContainerText = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__IconContainer",
  componentId: "sc-c82n6q-0"
})(["height:20px;width:16px;display:flex;align-items:center;margin-right:4px;"]);

exports.IconContainer = IconContainer;

var SubtitleBlock = _styledComponents["default"].span.withConfig({
  displayName: "styles__SubtitleBlock",
  componentId: "sc-c82n6q-1"
})(["font-size:12px;line-height:16px;color:", ";padding-right:8px;"], function (_ref) {
  var $active = _ref.$active;
  return $active ? 'var(--orange)' : 'var(--grey1)';
});

exports.SubtitleBlock = SubtitleBlock;

var TitleBlock = _styledComponents["default"].div.withConfig({
  displayName: "styles__TitleBlock",
  componentId: "sc-c82n6q-2"
})(["display:flex;align-items:start;"]);

exports.TitleBlock = TitleBlock;

var LabelText = _styledComponents["default"].span.withConfig({
  displayName: "styles__LabelText",
  componentId: "sc-c82n6q-3"
})(["font-size:16px;line-height:20px;font-weight:500;"]);

exports.LabelText = LabelText;

var ContainerText = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContainerText",
  componentId: "sc-c82n6q-4"
})(["display:flex;flex-direction:column;"]);

exports.ContainerText = ContainerText;